<div class="container">
  <ul class="info-list">
    <!-- <li *ngIf="showInfo[0]">
      <span class="label">Session</span>:<span class="value">11.0.133.181</span>
    </li> -->
    <li *ngIf="showInfo[0]">
      <span class="label">Browser</span>:<span class="value">{{ reportModel.browser }}</span>
    </li>
    <li *ngIf="showInfo[1]">
      <span class="label">Time Delay</span>:<span class="value">{{ getDelayInSeconds() }}</span>
    </li>
    <li *ngIf="showInfo[2]">
      <span class="label">Screen Resolution</span>:<span class="value">{{ reportModel.resolution }}</span>
    </li>
  </ul>
  <div class="image-section">
    <div class="logo_div">
      <ng-container *ngIf="reportModel?.browser?.length">
        <ng-container *ngFor="let browser of reportModel.browser">
          <img class="logo" [src]="'/assets/images/' + browser.toLowerCase() + 'logo.png'" [alt]="browser + ' Logo'">
        </ng-container>
      </ng-container>
      <ng-container *ngIf="reportModel?.emulators?.length">
        <img class="logo" src="/assets/images/android.webp" alt="androidLogo">
      </ng-container>
    </div>
    <p class="massage">{{ currentMessage }}</p>
  </div>
  <mat-progress-bar mode="determinate" [value]="progressBarValue"></mat-progress-bar>
</div>